module.exports = __webpack_public_path__ + "static/img/statistice-daynum.effa0853.png";